import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CopilotToolsAPI from '../../api/copilot/tools';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalEntries: 0,
    perPage: 25,
  },
  uiFlags: {
    fetchingList: false,
    deletingItem: false,
    updatingItem: false,
    creatingItem: false,
  },
};

const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  async get({ commit, state: _state }, params = {}) {
    commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { fetchingList: true });
    try {
      const response = await CopilotToolsAPI.get(params);
      const payload = response.data?.payload || [];
      const meta = response.data?.meta || {};
      commit(types.default.SET_COPILOT_TOOLS, payload);
      commit(types.default.SET_COPILOT_TOOLS_META, {
        currentPage: meta.page || 1,
        totalEntries: meta.total_count || payload.length,
        perPage: meta.per_page || _state.meta?.perPage || 25,
      });
      commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { fetchingList: false });
      return payload;
    } catch (error) {
      commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  async create({ commit }, payload) {
    commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { creatingItem: true });
    try {
      const response = await CopilotToolsAPI.create(payload);
      const record = response.data?.payload || response.data;
      if (record) {
        commit(types.default.ADD_COPILOT_TOOLS, record);
      }
      return record;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { creatingItem: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { deletingItem: true });
    try {
      await CopilotToolsAPI.delete(id);
      commit(types.default.DELETE_COPILOT_TOOLS, id);
      return true;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { deletingItem: false });
    }
  },

  async update({ commit }, { id, payload }) {
    commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { updatingItem: true });
    try {
      const response = await CopilotToolsAPI.update(id, payload);
      const record = response.data?.payload || response.data;
      if (record) {
        commit(types.default.EDIT_COPILOT_TOOLS, record);
      }
      return record;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_COPILOT_TOOLS_UI_FLAG, { updatingItem: false });
    }
  },
};

const mutations = {
  [types.default.SET_COPILOT_TOOLS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_COPILOT_TOOLS]: MutationHelpers.set,
  [types.default.ADD_COPILOT_TOOLS]: MutationHelpers.create,
  [types.default.DELETE_COPILOT_TOOLS]: MutationHelpers.destroy,
  [types.default.EDIT_COPILOT_TOOLS]: MutationHelpers.update,
  [types.default.SET_COPILOT_TOOLS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
